import { WarehouseOutlineSegment } from '@damofire/data-watson';
import { CanvasRenderer } from '@damofire/uix-commons';
import { DEFAULT_OUTLINE_CFG } from './canvas.cfg';

export class OutlineLayoutRenderer extends CanvasRenderer {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    private readonly warehouseSegment: WarehouseOutlineSegment,
  ) {
    super();
  }

  draw(): void {
    this.ctx.save();

    const begin = this.warehouseSegment.vertices[0];

    this.ctx.beginPath();
    this.ctx.moveTo(begin.x, begin.y);

    this.warehouseSegment.vertices.slice(1).forEach((to) => this.ctx.lineTo(to.x, to.y));

    this.ctx.lineWidth = DEFAULT_OUTLINE_CFG.strokeWidth;
    this.ctx.strokeStyle = DEFAULT_OUTLINE_CFG.stroke;
    this.ctx.stroke();

    this.ctx.restore();
  }
}
